import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
interface CountdownProps {
  title?: string;
  warning?: string;
}
export function Countdown({
  title = '⏰ PRECIO DE LANZAMIENTO — CIERRA EN:',
  warning
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 sm:px-6 lg:px-8" data-id="element-35">
      <div className="max-w-3xl mx-auto text-center" data-id="element-36">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-37">
          <ClockIcon className="w-5 h-5 text-[#E85D5D]" data-id="element-38" />
          <h3 className="text-xl sm:text-2xl font-bold text-[#1A1A1A]" data-id="element-39">
            {title}
          </h3>
        </div>

        <div className="grid grid-cols-3 gap-4 max-w-md mx-auto mb-6" data-id="element-40">
          <div className="bg-white border-2 border-[#E85D5D] shadow-sm rounded-lg p-4" data-id="element-41">
            <div className="text-4xl sm:text-5xl font-bold text-[#E85D5D] mb-1" data-id="element-42">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <div className="text-sm text-[#6B7280] font-medium" data-id="element-43">hs</div>
          </div>
          <div className="bg-white border-2 border-[#E85D5D] shadow-sm rounded-lg p-4" data-id="element-44">
            <div className="text-4xl sm:text-5xl font-bold text-[#E85D5D] mb-1" data-id="element-45">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-sm text-[#6B7280] font-medium" data-id="element-46">min</div>
          </div>
          <div className="bg-white border-2 border-[#E85D5D] shadow-sm rounded-lg p-4" data-id="element-47">
            <div className="text-4xl sm:text-5xl font-bold text-[#E85D5D] mb-1" data-id="element-48">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-sm text-[#6B7280] font-medium" data-id="element-49">seg</div>
          </div>
        </div>

        {warning && <p className="text-[#E85D5D] font-semibold" data-id="element-50">{warning}</p>}
      </div>
    </section>;
}